<template>
  <div id="footer">
    <!-- 热点问题输入联想等的slot -->
    <!-- 当前提问范围状态等的展示 -->
    <!-- 暂时注释掉热点资讯2025年3月19日 <pop-list
      ref="popList"
      :show.sync="verbDisplay"
      @on-selected="selectedItem"
    ></pop-list> -->
    <div class="voice-load" v-if="loadding">
      <img src="@/assets/icons/speaking.gif" alt="" width="80%">

    </div>
    <div style="position: relative; z-index: 20;">
      <div class="footer-state-wrapper">
        <div class="footer-state-box">
          <!-- 范围的提示 -->
          <div class="state-area" v-if="navigation || examId">
            <button @click="examGoBack">{{ btnText }}</button>
            您已选择“
            <em :title="exam ? exam.name : ''">{{ exam ? (exam.name.length > 10 ? (exam.name.substring(0, 10) + '...') :
              exam.name) : '无' }}</em> ”{{text1}}，{{ text }}
          </div>
        </div>
      </div>
      <!-- 输入框的位置 -->
      <div class="footer-wrapper" ref="footer">
        <!--展示微信端样式-->
        <div class="footer-voice2" v-if="voiceEnabled" @click="switchClick(1)"></div>
        <!--语音识别-->
        <div class="footer-input2" v-if="voiceEnabled ">
          <button @touchstart="gtouchstart($event)" @touchmove="gtouchmove()" @touchend="gtouchend()" type="danger"
            :class="loadding==true ? 'buttonSh2' : 'buttonSh' ">按住说话</button>
        </div>
        <div class="footer-container" v-if="!voiceEnabled ">
          <!--展示pc端样式-->
          <div class="footer-voice" @click="switchClick(2)" v-if="voiceEnabledWecht"></div>
          <div class="footer-input">

            <div class="footer-send-btn" @click="sendQuestion"></div>
            <div class="footer-textarea-wrapper">
              <textarea rows="1" ref="input" maxlength="50" v-model="question" @input="verbInput" @focus="verbInput"
                @blur="verbHide" @keypress.enter.prevent="sendQuestion" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PopList from '@/components/PopList'
import { mapState, mapGetters } from 'vuex'
import ProcessMessage from '@/utils/message.filter'
import ExpandingArea from '@/plugins/expandingArea'
import { buildData } from '@/components/Bubbles/interface'
import { wxConfig, exitScene } from '@/api/chat'
import wx from 'weixin-jsapi'

import _ from 'lodash'

export default {
  name: 'AppFooter',
  data () {
    return {
      timeOutEvent: 0,
      loadding: false,
      voiceEnabledWecht: null,
      voiceEnabled: false,
      lines: 1,
      verbDisplay: false,
      question: '',
      footerHeight: 0,
      input: null,
      text: '',
      btnText: '',
      text1: ''
    }
  },
  computed: {
    ...mapState(['messages', 'appConfig', 'navigation', 'level', 'voice', 'examId', 'examName']),
    ...mapGetters(['exam']),
    style () {
      const lineHeight = 0.38
      const maxLines = 3

      return {
        height: this.lines * lineHeight + 'rem',
        overflow: this.lines > maxLines ? 'auto' : 'hidden'
      }
    },

    validMessage () {
      const processMessage = new ProcessMessage(this.question)
      const { message: question } = processMessage.dropSpaces().dropEmoji()

      return question
    }
  },
  watch: {
    question () {
      setTimeout(() => {
        console.log(this.footerHeight)
        this.footerHeight = this.$refs.footer.offsetHeight
      }, 205)
    },
    level (value) {
      switch (value) {
        case 1:
          this.text1 = ''
          this.text = '其他栏目请点击'
          this.btnText = '其他栏目'
          break
        case 2:
          this.text1 = ''
          this.text = '其他类别请点击'
          this.btnText = '其他类别'
          break
        case 3:
          this.text1 = ''
          this.text = '其他问题请点击'
          this.btnText = '其他问题'
          break
        case 4:
          this.text1 = ''
          this.text1 = '问题'
          this.text = '返回首页请点击'
          this.btnText = '返回首页'
          break
        default:
          this.text1 = ''
          this.text = ''
          this.btnText = ''
          break
      }
    },
    validMessage (value) {
      // 检索数据
      // this.verbInput()
    },
    footerHeight: {
      immediate: true,
      handler (value) {
        this.$store.commit('updateLayout', {
          footerHeight: value
        })
      }
    }
  },
  methods: {
    // config 获取
    wxConfigClick () {
      //  const data = await wechatConfig(location.href.split('#')[0])
      var url = location.href
      // var url = location.href
      var wxJson = wxConfig(url)
      const jsons = Promise.resolve(wxJson)
      console.log(wx)
      jsons.then(function (data) {
        if (data.code === 0) {
          // 注册
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appid, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'startRecord',
              'stopRecord',
              'playVoice',
              'onVoiceRecordEnd',
              'translateVoice',
              'uploadVoice',
              'onVoicePlayEnd',
              'downloadVoice'
            ] // 必填，需要使用的JS接口列表
          })
          wx.error(function (res) {
            console.log('错误', res)
          })
          // 是否成功
          wx.ready(function (res) {
            console.log([res, 90])
          })
        }
      })
    },
    // 提问问题
    sendQuestion (dataType) {
      console.log(dataType)
      if (this.validMessage.length < 1) {
        return false
      }
      // 检查是否存在输入有效的内容
      if (!dataType) dataType = 'footer-keyboard'
      this.$store.dispatch('askQuestion', {
        from: 2,
        type: 0,
        question: this.validMessage,
        dataType: dataType
      })
      this.$store.dispatch('deepseekChat', {
        from: 2,
        type: 0,
        text: this.validMessage,
        dataType: dataType
      })
      // 隐藏联想列表
      this.verbDisplay = false
      this.$nextTick(() => {
        this.question = ''
        this.$nextTick(() => {
          this.input.setStyle(true)
        })
      })
    },
    // 查找联想问题
    verbInput: _.throttle(function () {
      // 若选择了栏目或是输入框输入了内容
      if (this.question) {
        // this.$refs.popList.update(this.validMessage)
      } else {
        if (this.navigation) {
          // this.$refs.popList.update(this.validMessage)
        } else {
          this.verbDisplay = false
        }
      }
    }, 100, {
      trailing: true
    }),
    verbHide () {
      // var self = this
      // setTimeout(function () {
      //   self.verbDisplay = false
      // }, 800)
    },
    // 选择推荐问题处理
    selectedItem (data) {
      this.question = data.desc
      this.show = false
      this.$nextTick(() => {
        this.input.setStyle(true) // 计算输入框高度
      })
    },
    // 开始录音
    start (e) {
      // e.preventDefault()
      const that = this
      that.stop()
      that.time = 0
      wx.startRecord({
        success: function (e) {
          that.loadding = true
          console.log(e, '成功调取录音')
          // alert('成功调起录音')
          that.timer = setInterval(() => {
            that.time++
          }, 1000)
          that.vicoeEnd()
        },
        fail: function (error) {
          that.loadding = false
          console.log(JSON.stringify(error))
        },
        cancel: function () {
          that.loadding = false
          alert('用户拒绝授权录音')
        }
      })
      wx.onVoiceRecordEnd({
        // 录音时间超过一分钟没有停止的时候会执行 complete 回调
        complete: function (res) {
          // var localId = res.localId
        }
      })
    },
    // 60秒监听
    vicoeEnd () {
      const that = this
      wx.onVoiceRecordEnd({
        // 录音时间超过一分钟没有停止的时候会执行 complete 回调
        complete: function (res) {
          // 60秒停止录音
          this.loadding = false
          // that.localId = res.localId
          clearInterval(that.timer)
        }
      })
    },
    // 开始按
    gtouchstart: function gtouchstart (item) {
      // item.stopPropagation()
      console.log(item, '按下去')
      item.stopPropagation()
      var _this = this
      this.timeOutEvent = setTimeout(function () {
        _this.start(item)
      }, 100)// 这里设置定时器，定义长按500毫秒触发长按事件，时间可以自己改，个人感觉500毫秒非常合适
      return false
    },
    // 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gtouchend: function gtouchend (item) {
      var _this = this
      clearTimeout(this.timeOutEvent)// 清除定时器
      if (this.timeOutEvent !== 0) {
        // 这里写要执行的内容（尤如onclick事件）
        _this.stop()
      }
      return false
    },
    // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gtouchmove: function gtouchmove () {
      clearTimeout(this.timeOutEvent)// 清除定时器
      // this.timeOutEvent = 0
    },
    // 停止录音
    stop () {
      const that = this
      clearInterval(that.timer)
      wx.stopRecord({
        success: function (res) {
          // alert('停止')
          console.log(res)
          that.loadding = false
          // that.upVoice()
          wx.translateVoice({
            localId: res.localId, // 需要识别的音频的本地Id，由录音相关接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (res) {
              that.question = res.translateResult
              that.sendQuestion()
              // alert(JSON.stringify(res))
            }
          })
        },
        fail: function (error) {
          console.log(error)
        }
      })
    },

    // 真正长按后应该执行的内容
    longPress: function longPress (item) {
      this.timeOutEvent = 0
      // 执行长按要执行的内容，如弹出菜单
    },
    // 考试场景切换
    examGoBack () {
      /**
         * 重新推送考试列表
         * 会话列表从后向前查找到 type=exam 的数据，添加到列表中
         */
      console.log('examGoBack:' + this.$store.state.level)
      if (this.level === 4) {
        // 返回首页
        const examList = _.findLast(this.messages, item => item.type === 17)
        if (examList) {
          this.$store.commit('appendBubble', this.messages[0])
          this.$store.commit('appendBubble', examList)
          const examList1 = _.findLast(this.messages, item => item.type === 2)
          if (examList1) {
            this.$store.commit('appendBubble', examList1)
          }
          const it = {
            type: 18,
            content: '您也可以点击“近期热点咨询”或在输入框内直接输入您的问题'
          }
          this.$store.commit('appendBubble', buildData(it))
          this.$store.commit('appendBubble', this.voice[0])
        }
        this.$store.commit('storeNavigation', null)
        this.$store.commit('updateExam', null)
        this.$store.commit('updateExamId', null)
        this.$store.commit('updateExamName', null)
      } else if (this.level === 3) {
        const cc = []
        cc.push({
          type: 0,
          style: true,
          content: '请选择您要咨询的问题：'
        })
        cc.push({
          type: 23,
          content: this.exam.message.content
        })
        // 从消息列表中找到语音文件
        const chooseQuestionPls = _.findLast(this.voice, item => (item.dataType === 'exam-selected' || item.dataType === 'subQuestion-selected'))
        console.log(chooseQuestionPls)
        cc.push(chooseQuestionPls)
        this.$store.commit('appendBubble', cc)
        // 切换level
        this.$store.commit('updateLevel', 2)
        // 切换考试
        this.$store.commit('updateExam') // 自动向上查找s
        // 退出当前的场景
        exitScene({
          chatId: this.appConfig.chatId,
          platform: this.appConfig.platform,
          orgCode: this.appConfig.orgCode,
          token: this.appConfig.token,
          navigationId: this.navigationId,
          question: this.examName,
          sid: this.$store.state.params.sid
        })
      } else if (this.level === 1) {
        const examList = _.findLast(this.messages, item => item.type === 17)
        if (examList) {
          this.$store.commit('appendBubble', examList)
          const it = {
            type: 18,
            content: '咨询其他问题您可以直接在输入框输入'
          }
          this.$store.commit('appendBubble', buildData(it))
        }
        this.$store.commit('storeNavigation', null)
        this.$store.commit('updateExam', null)
        this.$store.commit('updateExamId', null)
        this.$store.commit('updateExamName', null)
      } else {
        const examList = _.findLast(this.messages, item => item.type === 'exam')
        if (examList) {
          this.$store.commit('appendBubble', examList)
          const it = {
            type: 18,
            content: '咨询其他问题您可以直接在输入框输入'
          }
          this.$store.commit('appendBubble', buildData(it))
        }
        this.$store.commit('updateExam', null)
        this.$store.commit('updateExamId', null)
      }
    },
    // 切换展示图标
    switchClick (e) {
      console.log(e)
      if (e === 1) {
        this.voiceEnabled = false
      } else {
        this.voiceEnabled = true
      }
      console.log(this.voiceEnabled)
    }
  },
  components: {
    // [PopList.name]: PopList
  },
  mounted () {
    this.wxConfigClick()
    this.input = new ExpandingArea(this.$refs.input)
    this.footerHeight = this.$refs.footer.offsetHeight
    console.log('====this.env====:', this.env)
    if (this.env === 'weChat' && this.appConfig.voiceInput) {
      this.voiceEnabled = false
      this.voiceEnabledWecht = true
    }
  }
}
</script>

<style lang="scss" scoped>
  #footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;

    .footer-state-wrapper {
      padding-top: 10px;
      overflow: hidden;

      .footer-state-box {
        background-color: #fff;
        // padding-top: 10px;
        padding-left: 0.26rem;
        padding-right: 0.1rem;
        border-radius: 8px 8px 0 0;
        box-shadow: 0 0 10px rgba(79, 79, 79, 0.37);
        overflow: hidden;
      }

      .state-area {
        font-size: 0.14rem;
        line-height: 2em;
        color: #a8a5a5;
        margin-top: 0.08rem;
        margin-bottom: 0.05rem;
        @include clear();

        em {
          font-style: normal;
          @include font_color("theme-color-2");
        }

        button {
          float: right;
          @include button;
        }
      }
    }

    .voice-load {
      position: fixed;
      top: 50%;
      left: 50%;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 5px;
      width: 130px;
      height: 150px;
      margin-left: -60px;
      margin-top: -60px;
      text-align: center;
      color: #fff;
      font-size: px2rem(14);
      z-index: 102;

      img {
        width: 120px;
      }
    }

    .footer-wrapper {
      background-color: #fff;
      display: flex;
      align-items: center;
      height: 0.55rem;
      padding: 0.05rem 0.12rem 0.12rem 0.12rem;

      .footer-container {
        width: 100%;
        display: flex;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
      }

      .footer-voice {
        width: 0.48rem;
        min-width: 0.48rem;
        height: 0.48rem;
        border-radius: 0.48rem;
        margin-right: 8px;
        @include icon("theme-icon3");
        background-size: 50% 70% !important;
        background-position: center center !important;
        border: 1px solid #d2d2d2;
        cursor: pointer;
      }

      .footer-voice2 {
        width: 0.48rem;
        min-width: 0.48rem;
        height: 0.48rem;
        border-radius: 0.48rem;
        margin-right: 8px;
        @include icon("theme-icon4");
        background-size: 70% 50% !important;
        background-position: center center !important;
        border: 1px solid #d2d2d2;
        cursor: pointer;
      }

      .footer-input {
        position: relative;
        z-index: 1;
        width: 100%;
        border: 1px solid #d2d2d2;
        border-radius: 20px;
        padding-right: 0.42rem;
        overflow: hidden;
        @include clear();

        .footer-textarea-wrapper {
          padding: 0.10rem 0.12rem 0.05rem;
        }

        textarea {
          display: block;
          // margin-top: 0.08rem;
          // margin-bottom: 0.08rem;
          width: 100%;
          height: 0.20rem;
          font-size: 0.16rem;
          color: #b0a8a8;
          line-height: 1.5em;
          border: 0;
          outline: 0;
          resize: none;

          &::-webkit-scrollbar {
            display: none;
          }
        }
      }

      .footer-input2 {
        position: relative;
        z-index: 1;
        width: 100%;
        border-radius: 20px;
        overflow: hidden;
        @include clear();

        .buttonSh {
          width: 100%;
          height: 45px;
          border-radius: 15px;
          color: #fff;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          border: none;
          @include background_color("theme-color-1");
        }

        .buttonSh2 {
          width: 100%;
          height: 45px;
          border-radius: 15px;
          color: #fff;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          border: none;
          opacity: 0.5;
          @include background_color("theme-color-1");
        }
      }

      .footer-send-btn {
        position: absolute;
        z-index: 5;
        right: 0.04rem;
        top: 50%;
        width: 0.36rem;
        height: 0.36rem;
        transform: translateY(-50%);
        border-radius: 0.36rem;
        @include icon("theme-icon1");
        background-size: contain;
        background-size: 100% 100% !important;
        cursor: pointer;
      }
    }
  }

  /* // .is-mobile .footer-input textarea {
  //   margin-top: 0.11rem!important;
  // } */
</style>
